import { createContext } from 'react';
export const LabSetUpTabContext = createContext();